export default __webpack_public_path__ + "static/media/Bonus_History_Active_Income_Plan.4a0672c8.pdf";